"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSecureDocumentsContext;

var _react = require("react");

var _tsInvariant = _interopRequireDefault(require("ts-invariant"));

var _context = require("../../context");

function useSecureDocumentsContext() {
  var _useContext = (0, _react.useContext)(_context.SecureDocumentsProvider.Context),
      client = _useContext.client;

  (0, _tsInvariant.default)(client, 'No Secure Documents Client instance can be found. Please ensure that you ' + 'have called `SecureDocumentsProvider` higher up in your tree.');
  return client;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0L3VzZVNlY3VyZURvY3VtZW50c0NvbnRleHQudHMiXSwibmFtZXMiOlsidXNlU2VjdXJlRG9jdW1lbnRzQ29udGV4dCIsIlNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIiwiQ29udGV4dCIsImNsaWVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBR0E7O0FBRWUsU0FBU0EseUJBQVQsR0FBNEQ7QUFBQSxvQkFDdEQsdUJBQVdDLGlDQUF3QkMsT0FBbkMsQ0FEc0Q7QUFBQSxNQUNqRUMsTUFEaUUsZUFDakVBLE1BRGlFOztBQUV6RSw0QkFDRUEsTUFERixFQUVFLDhFQUNFLCtEQUhKO0FBS0EsU0FBT0EsTUFBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBpbnZhcmlhbnQgZnJvbSAndHMtaW52YXJpYW50JztcblxuaW1wb3J0IHsgU2VjdXJlRG9jdW1lbnRzQ2xpZW50IH0gZnJvbSAnLi4vLi4vLi4vY29yZSc7XG5pbXBvcnQgeyBTZWN1cmVEb2N1bWVudHNQcm92aWRlciB9IGZyb20gJy4uLy4uL2NvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0KCk6IFNlY3VyZURvY3VtZW50c0NsaWVudCB7XG4gIGNvbnN0IHsgY2xpZW50IH0gPSB1c2VDb250ZXh0KFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQpO1xuICBpbnZhcmlhbnQoXG4gICAgY2xpZW50LFxuICAgICdObyBTZWN1cmUgRG9jdW1lbnRzIENsaWVudCBpbnN0YW5jZSBjYW4gYmUgZm91bmQuIFBsZWFzZSBlbnN1cmUgdGhhdCB5b3UgJyArXG4gICAgICAnaGF2ZSBjYWxsZWQgYFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyYCBoaWdoZXIgdXAgaW4geW91ciB0cmVlLicsXG4gICk7XG4gIHJldHVybiBjbGllbnQ7XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useSecureDocumentsContext/useSecureDocumentsContext.js
// module id = 1841
// module chunks = 0